// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2dAp7","vLegacy":"SelectSecondary_vLegacy__2ThIL","error":"SelectSecondary_error__vP_gE","disabled":"SelectSecondary_disabled__1-krP"};